// More words will be added soon. See issue #920.
module.exports = function() {
	return [
		"having",
	];
};



// WEBPACK FOOTER //
// ./node_modules/yoastseo/js/researches/english/passivevoice/having.js